(function () {
	const initHeader = () => {
		const header = document.querySelector(".shopify-section-header");

		// Auf Seiten ohne Header muss das Skript nichts initialisieren.
		if (!header) return;

		// Verhindert doppelte Event-Listener im Shopify Theme-Editor.
		if (header.dataset.headerJsInitialized === "true") return;
		header.dataset.headerJsInitialized = "true";

		const menu = document.querySelector(
			".header__second-level .list-menu--inline",
		);
		const menuLinks = document.querySelectorAll(
			".header__second-level .list-menu-item",
		);
		const megaMenuLink = document.querySelector(".list-menu--megamenu");
		const searchModal = document.querySelector(
			"details-modal.header__search > details",
		);
		const allSubmenu = document.querySelectorAll(".header__submenu");
		const searchOpenBtn = document.querySelectorAll(".search-open-btn");
		const searchOpenBtnFooter = document.querySelector(
			".search-open-btn--footer",
		);
		const searchInner = document.querySelectorAll(".header__search-inner");
		const searchPromoBg = document.querySelector(".search__modal");
		const searchPredictiveBg = document.querySelectorAll(
			".search-modal__form",
		);
		const headerSimpleMenuLinks = document.querySelectorAll(
			".simple_mega_menu .header__submenu-li",
		);

		const blob = document.getElementById("blob");
		const track = document.querySelector(
			".header__second-level .list-menu--inline",
		);
		const activeItem = document
			.querySelector(
				".header__second-level .list-menu--inline .header__active-menu-item",
			)
			?.closest("li");

		let hasBlobPosition = false;

		if (blob) {
			blob.style.opacity = "0";
			blob.style.left = "0px";
			blob.style.top = "0px";
		}

		headerSimpleMenuLinks.forEach((link) => {
			link.addEventListener("mouseenter", (event) => {
				headerSimpleMenuLinks.forEach((element) => {
					const submenu = element.querySelector(".header__submenu");
					if (!submenu) return;

					if (element === event.currentTarget) {
						submenu.classList.add("show-submenu");
						submenu.classList.remove("remove-submenu");
					} else {
						submenu.classList.remove("show-submenu");
						submenu.classList.add("remove-submenu");
					}
				});
			});
		});

		const addHeaderOverlay = (trigger) => {
			if (!trigger) return;

			trigger.addEventListener("mouseover", () => {
				document.querySelector(".header__overlay")?.classList.add("visible");
			});

			trigger.addEventListener("mouseout", () => {
				document.querySelector(".header__overlay")?.classList.remove("visible");
			});
		};

		addHeaderOverlay(megaMenuLink);

		const makeBlob = (target = activeItem) => {
			if (!target || !blob) return;

			blob.style.width = `${target.clientWidth}px`;
			blob.style.height = `${target.clientHeight}px`;
			blob.style.left = `${target.offsetLeft}px`;
			blob.style.top = `${target.offsetTop}px`;
			blob.style.opacity = "1";
			blob.style.backgroundColor = "rgb(var(--color-accent))";
		};

		const hideBlob = () => {
			if (!blob) return;
			blob.style.backgroundColor = "transparent";
		};

		const animateBlob = (from, to) => {
			if (!from || !to || !blob) return;

			const keyframes = [
				{
					left: `${from.offsetLeft}px`,
					width: `${from.clientWidth}px`,
					top: `${from.offsetTop}px`,
					opacity: "1",
				},
				{
					left: `${to.offsetLeft}px`,
					width: `${to.clientWidth}px`,
					top: `${to.offsetTop}px`,
					opacity: "1",
				},
			];

			blob.animate(keyframes, {
				duration: 300,
				easing: "cubic-bezier(0.87, 0, 0.13, 1)",
				fill: "forwards",
			});
		};

		if (activeItem && blob) {
			makeBlob(activeItem);
			hasBlobPosition = true;
		} else {
			hideBlob();
		}

		// Die animierte Navigationsmarkierung wird nur eingerichtet,
		// wenn sowohl die Navigation als auch das Blob-Element existieren.
		if (track && blob) {
			track.addEventListener("mouseover", (event) => {
				const eventTarget =
					event.target instanceof Element ? event.target : null;
				const targetItem = eventTarget?.closest(".list-menu-item");

				if (!targetItem || targetItem.id === "blob") return;

				blob.style.backgroundColor = "rgb(var(--color-accent))";

				if (!hasBlobPosition) {
					makeBlob(targetItem);
					blob.animate([{ opacity: 0 }, { opacity: 1 }], {
						duration: 300,
						easing: "ease-out",
						fill: "forwards",
					});
					hasBlobPosition = true;
					return;
				}

				animateBlob(blob, targetItem);
			});

			track.addEventListener("mouseleave", () => {
				if (activeItem) {
					animateBlob(blob, activeItem);
				} else {
					hideBlob();
				}
			});
		}

		window.addEventListener("resize", () => {
			if (activeItem && blob) makeBlob(activeItem);
		});

		header.addEventListener("keydown", (event) => {
			if (event.code !== "Escape") return;

			searchInner.forEach((item) => {
				item.classList.remove("header__search-inner--open");
			});
			document.body.classList.remove("overflow-hidden-search");
		});

		const announcementBar = document.querySelector(".section-announcement");

		if (announcementBar && "IntersectionObserver" in window) {
			window.eviAnnouncementBarObserver?.disconnect();

			window.eviAnnouncementBarObserver = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							const height = announcementBar.getBoundingClientRect().height;
							document.documentElement.style.setProperty(
								"--ann-height",
								`${(height * entry.intersectionRatio).toFixed(2)}px`,
							);
						} else {
							document.documentElement.style.setProperty(
								"--ann-height",
								"0px",
							);
						}
					});
				},
				{
					threshold: Array.from({ length: 1000 }, (_, index) => index / 1000),
				},
			);

			window.eviAnnouncementBarObserver.observe(announcementBar);
		} else {
			document.documentElement.style.setProperty("--ann-height", "0px");
		}

		menuLinks.forEach((link) => {
			link.addEventListener("mouseenter", () => {
				menuLinks.forEach((element) => {
					element.classList.add("list-menu-item--inactive");
					element.classList.remove("list-menu-item--active");
				});

				link.classList.remove("list-menu-item--inactive");
				link.classList.add("list-menu-item--active");
			});
		});

		menu?.addEventListener("mouseleave", () => {
			const activePageItem = Array.from(menuLinks).find((link) =>
				link.querySelector(".header__active-menu-item"),
			);

			menuLinks.forEach((element) => {
				element.classList.remove("list-menu-item--active");
				element.classList.remove("list-menu-item--inactive");
			});

			activePageItem?.classList.add("list-menu-item--active");
		});

		allSubmenu.forEach((submenu) => {
			const links = submenu.querySelectorAll(
				".header__submenu-item:not(.header__submenu-item--grandchild)",
			);

			links.forEach((link) => {
				link.addEventListener("mouseenter", (event) => {
					event.stopPropagation();

					links.forEach((element) => {
						element.classList.add("header__submenu-item--inactive");
					});

					link.classList.remove("header__submenu-item--inactive");
				});
			});

			submenu.addEventListener("mouseleave", (event) => {
				event.stopPropagation();
				links.forEach((element) => {
					element.classList.remove("header__submenu-item--inactive");
				});
			});
		});

		const openSearch = () => {
			searchInner.forEach((item) => {
				item.classList.add("header__search-inner--open");
			});
			document.body.classList.add("overflow-hidden-search");

			const searchContent = document.querySelector(".search__content");
			if (searchContent && typeof trapFocus === "function") {
				trapFocus(searchContent);
			}
		};

		searchOpenBtn.forEach((button) => {
			button.addEventListener("click", openSearch);
			button.addEventListener("keydown", (event) => {
				if (event.key === "Enter") openSearch();
			});
		});

		// Der Footer-Suchbutton ist optional. Er wurde im aktuellen Shop entfernt.
		searchOpenBtnFooter?.addEventListener("click", () => {
			window.scrollBy({
				top: -1,
				behavior: "smooth",
			});
		});

		searchInner.forEach((item) => {
			item.addEventListener("click", (event) => {
				if (event.target !== item) return;

				item.classList.remove("header__search-inner--open");
				document.body.classList.remove("overflow-hidden-search");
			});
		});

		searchPromoBg?.addEventListener("click", (event) => {
			const target = event.target instanceof Element ? event.target : null;
			if (!target?.classList.contains("search__modal")) return;

			searchInner.forEach((item) => {
				item.classList.remove("header__search-inner--open");
			});
			document.body.classList.remove("overflow-hidden-search");
		});

		searchPredictiveBg.forEach((item) => {
			item.addEventListener("click", (event) => {
				const target = event.target instanceof Element ? event.target : null;
				if (!target?.classList.contains("search-modal__form")) return;

				searchInner.forEach((searchItem) => {
					searchItem.classList.remove("header__search-inner--open");
				});
				document.body.classList.remove("overflow-hidden-search");
			});
		});

		const updateHeaderOverlayState = () => {
			if (searchModal?.hasAttribute("open")) {
				header.classList.add("color-background-overlay-hidden");
			} else {
				header.classList.remove("color-background-overlay-hidden");
			}
		};

		updateHeaderOverlayState();
		searchModal?.addEventListener("toggle", updateHeaderOverlayState);
	};

	document.addEventListener("shopify:section:load", initHeader);
	document.addEventListener("shopify:section:reorder", initHeader);

	initHeader();
})();
